<template>
  <SelectionList
    ref="SelectionList"
    :options="options"
    :modelValue="modelValue"
    :multi="multi"
    :clickable-option="true"
    :allow-empty-single-select="allowEmptySingleSelect"
    density="dense"
    @update:modelValue="$emit('update:modelValue', $event)"
    @focusout="onFocusout"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { ListOptions } from '../SelectionList.vue';

/**
 * SelectionList for use inside a PopoverMenu
 */
export default defineComponent({
  name: 'PopoverMenuSelectionList',

  emits: {
    'update:modelValue': null,
  },

  props: {
    options: {
      type: Array as PropType<ListOptions>,
      required: true,
    },

    modelValue: {
      required: true,
      type: [String, Number, Array, Symbol, Boolean],
    },

    multi: {
      type: Boolean,
      default: false,
    },

    allowEmptySingleSelect: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    /**
     * When the user tabs out of the selection list, or the focus is lost when the popover closes etc,
     * reset the highlight and focus state
     */
    onFocusout($event: FocusEvent) {
      if (!this.$refs.SelectionList.$el.contains($event.relatedTarget as Node)) {
        this.$refs.SelectionList?.resetPositionData();
        this.$refs.SelectionList?.resetFocusState();
      }
    },
  },
});
</script>
<style></style>
